export default __webpack_public_path__ + "static/media/5A1_Parents by Javier Lazo.1e9e1815.jpg";